<template>
  <div class="overflow-auto max-h-80">
    <table class="table table-striped">
      <tbody>
        <tr v-for="u in userRoutes" :key="u.id">
          <td>{{ u.passenger_name }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    userRoutes: {
      required: true,
      type: Array,
    },
  },
  data: () => {
    return {};
  },
};
</script>